import { DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutJobClassificationList extends Layout {
    layoutheaderJobClassificationList: LayoutHeader;
    sourceJobClassification: DataSource;
    tableJobClassifications: Table;
}
